// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2407":"ad36c0a9","9433":"566c0888"}[chunkId] + ".chunk.css";
};